if (!customElements.get('gi-zero-stock-request')) {
  class GiZeroStockRequest extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const data = this.querySelector('[data-gi-zero-stock-data]');
      if (!data) return;
      this.productData = JSON.parse(data.textContent);
      this.link = this.querySelector('a');
      this.owner = this.closest('product-form');
      this.initialized = true;
      this.link.addEventListener('click', () => this.updateLink());
      this.addEventListener('focusin', () => this.updateLink());
      if (this.closest('.thb-product-detail')?.querySelector('gi-nylatech-ordering')) {
        const wrapper = this.closest('.thb-product-detail');
        wrapper.addEventListener('input', () => this.updateLink());
        wrapper.addEventListener('change', () => this.updateLink());
      }
      this.setVariant(this.dataset.selectedId);
    }

    isEligible(id) {
      return this.productData?.variants.some(variant => String(variant.id) === String(id) && variant.eligible) || false;
    }

    setVariant(id) {
      if (!this.initialized) return;
      this.variant = this.productData.variants.find(variant => String(variant.id) === String(id));
      const eligible = Boolean(this.variant?.eligible);
      this.hidden = !eligible;
      if (this.owner) this.owner.dataset.giZeroStock = String(eligible);
      if (eligible) this.updateLink();
    }

    updateLink() {
      if (!this.variant) return;
      const form = document.getElementById(this.dataset.formId);
      const quantity = form?.elements.namedItem('quantity')?.value || '1';
      const url = new URL(this.productData.inquiryPath, window.location.origin);
      const productUrl = new URL(this.productData.url, window.location.origin);
      productUrl.searchParams.set('variant', this.variant.id);
      url.searchParams.set('product', this.productData.title);
      url.searchParams.set('product_url', productUrl.href);
      url.searchParams.set('quantity', quantity);
      if (this.variant.sku) url.searchParams.set('sku', this.variant.sku);
      let variantTitle = this.variant.title !== 'Default Title' ? this.variant.title : '';
      const ordering = this.closest('.thb-product-detail')?.querySelector('gi-nylatech-ordering');
      if (ordering) {
        const details = ordering.requestDetails();
        if (details.unit) variantTitle += `; selling unit ${details.unit}`;
        if (details.length) variantTitle += `; fixed length ${details.length} in`;
        if (details.cuts) variantTitle += `; cutting requirements: ${details.cuts}`;
      }
      if (variantTitle) url.searchParams.set('variant', variantTitle);
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      this.link.href = url.href;
    }
  }
  customElements.define('gi-zero-stock-request', GiZeroStockRequest);
}
